import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import EmailLeadCapture from '@components/EmailLeadCapture';
import MarketingLeadCaptureWithApple from '@components/LockedLeadCaptureForm/MarketingLeadCaptureWithApple';
import MarketingLeadCaptureWithGoogle from '@components/LockedLeadCaptureForm/MarketingLeadCaptureWithGoogle';
import useWindowSize from '@hooks/useWindowSize';
import { Theme } from '@interfaces/global';
import { create_lead_with_oauth_path } from '@routes';
import { READER_URL } from '@src/env';
import { FormLocation, LeadType } from '@utils/enums';

import { PaywallProps } from '.';

const PaywallForm = ({
  articleId,
  buttonText,
  briefingGuid,
  leadType = LeadType.ArticleLead,
  isPro,
  offerLink,
  shareGuid,
  subtitle,
  title,
  trackingProps,
  unlockContent,
}: PaywallProps): JSX.Element => {
  const returningUri = `${READER_URL}/${offerLink}`;
  const { width: windowWidth } = useWindowSize();

  return (
    <div className="flex w-full flex-col flex-nowrap content-center items-center justify-center px-24 pb-24 sm:px-64 md:justify-between md:pb-80">
      <header
        className={clsx('mb-16 flex w-full flex-col text-left sm:mb-64 sm:text-center', {
          'sm:w-[610px]': !isPro,
          'sm:w-[660px]': isPro,
        })}
      >
        <h1 className="mb-8 mt-0 font-suisse-works text-headline-sm text-white sm:mb-12 sm:text-headline-lg">
          {title}
        </h1>
        <p className="my-0 font-suisse-intl-mono text-overline-lg text-white">
          {ReactHtmlParser(subtitle)}
        </p>
      </header>

      <div className="w-full sm:w-[516px]">
        <div className="sm:row-auto sm:grid sm:grid-flow-row sm:grid-cols-2 sm:gap-x-16">
          <EmailLeadCapture
            articleId={articleId}
            buttonText={buttonText}
            briefingGuid={briefingGuid}
            formClassName="sm:col-span-2 mb-24"
            formLocation={FormLocation.Paywall}
            inputClassName="w-full"
            isPro={isPro}
            isVertical={windowWidth < 768}
            leadType={leadType}
            redirectUri={offerLink}
            trackingProps={{ ...trackingProps, name: 'subscribe' }}
            shareGuid={shareGuid}
            signInOptionClass="text-center sm:text-left"
            gdprClassName="mb-16"
            theme={Theme.Dark}
            unlockContent={unlockContent}
          />
          <div className="flex grid-flow-row-dense flex-col items-center sm:mb-0">
            <MarketingLeadCaptureWithGoogle
              formLocation={FormLocation.Paywall}
              eventName="createLeadWithGoogle"
              verificationUri={create_lead_with_oauth_path()}
              leadType={leadType}
              returningUri={returningUri}
            />
          </div>
          <div className="mt-8 flex flex-col items-center sm:mb-0 sm:mt-0">
            <MarketingLeadCaptureWithApple
              formLocation={FormLocation.Paywall}
              eventName="createLeadWithApple"
              verificationUri={create_lead_with_oauth_path()}
              leadType={leadType}
              returningUri={returningUri}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaywallForm;
